<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div class="list-block">
    <div class="list-block__inner">
      <div v-if="title" class="list-block__title">{{ title }}</div>
      <ul class="list-block__items">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="list-block__item"
        >
          <PostContent :content="item.content" />
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.list-block {
  position: relative;
  margin: 40px auto;
  max-width: var(--content-max-width);

  &__inner {
    padding: 24px;
    border-radius: 16px;
    background-color: rgba(var(--white-color--rgb), 70%);
    box-shadow: 0 0 32px rgba(255, 133, 235, 32%);
  }

  &__title {
    font-family: var(--title-font-family);
    font-size: var(--h3-font-size);
    line-height: var(--h3-line-height);
    font-weight: 700;
  }

  &__items {
    margin: 32px 0;
    font-size: var(--body-font-size);
    line-height: var(--body-line-height);
  }

  &__item {
    position: relative;
    margin-bottom: 16px;
    padding-left: 30px;

    &::before {
      content: '';
      margin-top: 12px;
      width: 8px;
      height: 8px;
      background-color: var(--accent-color);
      border-radius: 2px 2px 2px 0;
      position: absolute;
      left: 10px;
    }
  }

  &__item:last-child {
    margin-bottom: 0;
  }

  @media (--small-vp) {
    margin: 24px auto;

    &__inner {
      padding: 16px;
    }

    &__title {
      font-size: 24px;
      line-height: 30px;
    }

    &__items {
      margin: 16px 0;
      font-size: 16px;
      line-height: 22px;
    }

    &__item {
      position: relative;
      margin-bottom: 16px;
      padding-left: 16px;

      &::before {
        margin-top: 0;
        top: 6px;
        left: 0;
        width: 8px;
        height: 8px;
      }
    }
  }
}
</style>
